module.exports = __webpack_public_path__ + "img/clinica_cordoba.e2f8aae6.jpg";